import React, {type SVGProps} from 'react'

const StepCheckLined = (props: SVGProps<SVGSVGElement>) => {
  return (
    <>
      <svg
        style={{display: 'inline'}}
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 5.5L6 10L12.5 2"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}
export default StepCheckLined
